<template>
  <div class="template1">
    <!-- 主内容区 -->
    <div class="t1-content">
      <!-- 顶部推荐图 -->
      <div class="t1-top-banner">
        <img src="/static/image/event/2035233566223306753_00.avif" class="top-banner-img" alt="" />
        <!-- <div class="t1-top-menu">
          <div class="t1-menu-item" v-for="(item, i) in topMenuItems" :key="i">
            <img :src="item.icon" class="menu-icon" alt="" />
          </div>
        </div> -->
      </div>

      <!-- 活动详情+特惠整体区块 -->
      <div class="t1-card">
        <!-- 活动详情 -->
        <div v-if="activityData.content">
          <div class="t1-card-title">活动详情</div>
          <div class="t1-text" v-html="activityData.content"></div>
        </div>

        <!-- 特惠一标题 -->
        <!-- <div class="t1-special-title" v-if="activityData.special1">
          <img src="/static/image/event/1927710978682740738_0000.gif" class="fire-icon" alt="" />
          <span>{{ activityData.special1Title || '逢2会员日特惠一' }}</span>
          <img src="/static/image/event/1927710978682740738_0000.gif" class="fire-icon" alt="" />
        </div> -->

        <!-- 特惠一表格 -->
        <div class="t1-table-wrap" v-if="activityData.special1">
          <table class="t1-table t1-table-special1">
            <thead>
              <tr>
                <th v-for="(col, ci) in activityData.special1.columns" :key="ci">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, ri) in activityData.special1.rows" :key="ri">
                <td v-if="ri === 0" :rowspan="activityData.special1.rows.length" class="merge-cell">{{ row[0] }}</td>
                <td>{{ row[1] }}</td>
                <td v-if="ri === 0" :rowspan="activityData.special1.rows.length" class="merge-cell-center">{{ row[2] }}</td>
                <td class="gold-text">{{ row[3] }}</td>
                <td v-if="ri === 0" :rowspan="activityData.special1.rows.length" class="merge-cell-right" v-html="row[4]"></td>
              </tr>
            </tbody>
          </table>
          <div class="t1-table-note" v-if="activityData.special1.note" v-html="activityData.special1.note"></div>
        </div>

        <!-- 特惠二标题 -->
        <!-- <div class="t1-special-title" v-if="activityData.special2">
          <img src="/static/image/event/1927710978682740738_0000.gif" class="fire-icon" alt="" />
          <span>{{ activityData.special2Title || '逢2会员日特惠二' }}</span>
          <img src="/static/image/event/1927710978682740738_0000.gif" class="fire-icon" alt="" />
        </div>

        特惠二表格
        <div class="t1-table-wrap" v-if="activityData.special2">
          <table class="t1-table t1-table-special2">
            <thead>
              <tr>
                <th v-for="(col, ci) in activityData.special2.columns" :key="ci">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, ri) in activityData.special2.rows" :key="ri">
                <td>{{ row[0] }}</td>
                <td class="gold-text">{{ row[1] }}</td>
                <td class="gold-text">{{ row[2] }}</td>
                <td v-if="ri === 0" :rowspan="activityData.special2.rows.length" class="merge-cell-center" v-html="row[3]"></td>
                <td class="gold-text">{{ row[4] }}</td>
              </tr>
            </tbody>
          </table>
          <div class="t1-table-note t1-table-note-red" v-if="activityData.special2.note" v-html="activityData.special2.note"></div>
        </div> -->
      </div>

      <!-- 参与条件卡片 -->
      <div class="t1-card t1-card-inline" v-if="activityData.conditions">
        <div class="t1-card-title">参与条件</div>
        <div class="t1-text" v-html="activityData.conditions"></div>
      </div>

      <!-- 领取方式卡片 -->
      <div class="t1-card t1-card-inline" v-if="activityData.receiveMethod">
        <div class="t1-card-title">领取方式</div>
        <div class="t1-text" v-html="activityData.receiveMethod"></div>
      </div>

      <!-- 活动说明/规则卡片 -->
      <div class="t1-card" v-if="activityData.memo">
        <div class="t1-card-title">活动规则</div>
        <div class="t1-rules">
          <template v-if="Array.isArray(activityData.memo)">
            <p v-for="(item, index) in activityData.memo" :key="index">{{ item }}</p>
          </template>
          <template v-else>
            <div v-html="activityData.memo"></div>
          </template>
        </div>
      </div>

      <!-- 底部推荐图横向滑动 -->
      <div class="t1-recommend" v-if="recommendList.length > 0" ref="recommendWrap">
        <div class="t1-recommend-inner" ref="recommendInner">
          <div
            v-for="(item, index) in recommendList"
            :key="index"
            class="t1-recommend-item"
            :ref="'recItem' + index"
            :class="{ 't1-recommend-active': item.activityId === String(activityData.id) }"
            @click="goRecommend(item)"
          >
            <img :src="item.image" class="t1-recommend-img" alt="" />
            <div class="t1-recommend-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="t1-footer" v-if="showFooter">
      <div class="t1-footer-info">
        <span>剩余申请次数：{{ applyCount }}</span>
        <span class="t1-refresh" @click="handleRefresh"> 刷新次数</span>
      </div>
      <div class="t1-footer-btns">
        <button class="t1-btn t1-btn-back" @click="$router.back()">返回</button>
        <button class="t1-btn t1-btn-apply" @click="handleApply">优惠申请</button>
      </div>
    </div>

    <!-- 弹框 -->
    <div class="popup-overlay" v-if="showPopup" @click.self="closePopup">
      <div class="popup-content">
        <div class="popup-close" @click="closePopup">
          <img src="/static/image/event/close_popup.png" alt="关闭" />
        </div>
        <div class="popup-body">
          <img :src="popupItem.image" class="popup-img" alt="" />
          <div class="popup-name">{{ popupItem.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { recommendList } from './activityConfig';

export default {
  name: 'template1',
  props: {
    activityData: {
      type: Object,
      default: () => ({}),
    },
    from: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      applyCount: 0,
      showPopup: false,
      popupItem: null,
      topMenuItems: [
        { icon: '/static/image/event/2011393739796230145_01.avif' },
        { icon: '/static/image/event/2011393940099739650_03.avif' },
        { icon: '/static/image/event/2011393978355408897_05.avif' },
        { icon: '/static/image/event/2011401711114338306_04.avif' },
        { icon: '/static/image/event/2011407427363807234_02.avif' },
      ],
      recommendList,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollToActive();
    });
  },
  computed: {
    sliderImages() {
      const id = this.activityData.id;
      if (!id) return [];
      const images = [];
      for (let i = 1; i <= 41; i++) {
        const num = String(i).padStart(5, '0');
        images.push(`/static/image/event/ActiveImg${id}_${num}.avif`);
      }
      return images;
    },
    currentActivityConfig() {
      const id = String(this.activityData.id);
      return this.recommendList.find(item => item.activityId === id) || {};
    },
    showFooter() {
      return this.currentActivityConfig.apply_show === 1;
    },
  },
  methods: {
    handleRefresh() {
      // 刷新次数逻辑后续补充
    },
    handleApply() {
      if (!this.$store.state.token) {
        this.$parent.showTost(0, '请先登录');
        return;
      }
      this.$parent.showLoading();
      this.$apiFun.post('/api/doactivityapply', { activityid: this.activityData.id }).then(res => {
        this.$parent.hideLoading();
        this.$parent.showTost(res.code === 200 ? 1 : 0, res.message);
        if (res.code === 200 && res.data) {
          this.applyCount = res.data.remaining || 0;
        }
      }).catch(() => {
        this.$parent.hideLoading();
      });
    },
    goRecommend(item) {
      if (item.popup === 1) {
        this.popupItem = item;
        this.showPopup = true;
      } else if (item.url_open === 1 && item.url) {
        window.location.href = item.url;
      } else if (item.jump) {
        this.$router.replace(`/activityDetail?template=${item.templateId}&activity_id=${item.activityId}&from=${this.from}`).catch(() => {});
      }
    },
    closePopup() {
      this.showPopup = false;
      this.popupItem = null;
    },
    scrollToActive() {
      const activeIndex = this.recommendList.findIndex(item => item.activityId === String(this.activityData.id));
      if (activeIndex === -1) return;

      const wrap = this.$refs.recommendWrap;
      const items = this.$refs['recItem' + activeIndex];
      if (!wrap || !items || !items[0]) return;

      const itemEl = items[0];
      const wrapWidth = wrap.offsetWidth;
      const itemLeft = itemEl.offsetLeft;
      const itemWidth = itemEl.offsetWidth;

      const scrollLeft = itemLeft - (wrapWidth / 2) + (itemWidth / 2);
      wrap.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
.template1 {
  padding-bottom: 1.2rem;
  background: #0a0a0a;
  min-height: 100vh;
}

.t1-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.15rem 0.2rem;
  background: #0a0a0a;
  font-size: 0.35rem;
  color: #fff;
  font-weight: 600;
  position: sticky;
  top: 46px;
  z-index: 10;

  .t1-title {
    flex: 1;
    text-align: center;
  }

  .t1-record {
    font-size: 0.28rem;
    color: #DFB372;
    white-space: nowrap;
  }
}

.t1-content {
  padding: 0.2rem;
  margin-bottom: 2rem;
}

.t1-top-banner {
  margin-bottom: 0;
  background: #0a0a0a;
  border-radius: 0.15rem;
  overflow: hidden;
  padding: 0.2rem;

  .top-banner-img {
    width: 100%;
    display: block;
  }
}

.t1-top-menu {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.2rem 0;

  .t1-menu-item {
    .menu-icon {
      width: 1.35rem;
    }
  }
}

.t1-banner {
  margin-bottom: 0.3rem;

  .banner-img {
    width: 100%;
    border-radius: 0.15rem;
  }
}

// 卡片区块（活动详情、领取方式、规则说明）
.t1-card {
  background: #0a0a0a;
  border-radius: 0.15rem;
  padding: 0.3rem;

  .t1-card-title {
    font-size: 0.3rem;
    color: #e7c356;
    font-weight: 600;
    text-align: left;
    margin-bottom: 0.15rem;
  }

  &.t1-card-inline {
    display: flex;
    align-items: center;
    padding: 0.15rem 0.3rem;

    .t1-card-title {
      flex-shrink: 0;
      margin-bottom: 0;
      margin-right: 0.05rem;
    }

    .t1-text {
      flex: 1;
    }
  }

  .card-title-icon {
    width: 50%;
    height: auto;
    display: block;
    margin: 0 auto 0.2rem;
  }

  .t1-text {
    font-size: 0.28rem;
    color: #fff;
    line-height: 1.6;
    text-align: left;
    width: 100%;
    font-weight: 600;
  }

}

// 特惠标题
.t1-special-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  margin: 0.25rem 0;

  .fire-icon {
    width: 0.5rem;
    height: auto;
  }

  span {
    font-size: 0.35rem;
    color: #44fbec;
    font-weight: bold;
  }
}

// 表格区块
.t1-table-wrap {
  margin-bottom: 0.1rem;
  margin-top: 0.3rem;
}

// 表格样式
.t1-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.28rem;

  thead th {
    background: #0a0a0a;
    color: #e7c356;
    padding: 0.15rem 0.1rem;
    text-align: center;
    font-weight: 600;
    font-size: 0.28rem;
    border: 1px solid #f1c40f;
  }

  tbody td {
    padding: 0.12rem 0.1rem;
    text-align: center;
    color: #fff;
    font-size: 0.28rem;
    font-weight: 600;
    border: 1px solid #f1c40f;
  }

  .gold-text {
    color: #fff;
    font-weight: 600;
  }

  .blue-text {
    color: #7c90f3;
    font-weight: 600;
  }

  .merge-cell {
    writing-mode: horizontal-tb;
    text-align: center;
    line-height: 1.6;
    white-space: pre-line;
    font-weight: 600;
  }

  .merge-cell-right {
    text-align: center;
    line-height: 1.6;
    white-space: pre-line;
    color: #fff;
    font-weight: 600;
  }
}

// 特惠一表格特殊样式
.t1-table-special1 {
  table-layout: fixed;

  th:nth-child(1) { width: 22%; }
  th:nth-child(2) { width: 18%; }
  th:nth-child(3) { width: 22%; }
  th:nth-child(4) { width: 18%; }
  th:nth-child(5) { width: 20%; }

  .merge-cell-center {
    text-align: center;
    line-height: 1.6;
    white-space: pre-line;
    color: #fff;
    font-weight: 600;
  }
}

// 特惠二表格特殊样式
.t1-table-special2 {
  table-layout: fixed;

  th:nth-child(1) { width: 16%; }
  th:nth-child(2) { width: 17%; }
  th:nth-child(3) { width: 17%; }
  th:nth-child(4) { width: 24%; }
  th:nth-child(5) { width: 16%; }

  .merge-cell-center {
    text-align: center;
    line-height: 1.6;
    white-space: pre-line;
    color: #fff;
    font-weight: 600;
  }
}

.t1-table-note {
  font-size: 0.28rem;
  color: #fff;
  margin-top: 0.15rem;
  line-height: 1.6;
  font-weight: 600;
}

// 底部推荐图
.t1-recommend {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 0.2rem;

  .t1-recommend-inner {
    display: flex;
    gap: 0.15rem;
    width: max-content;
    margin-top: 1rem;
  }

  .t1-recommend-item {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 0.1rem;
    box-sizing: border-box;
    padding: 2px;

    &.t1-recommend-active {
      box-shadow: 0 0 0 1px #d1ae52;
    }
  }

  .t1-recommend-img {
    width: 2.5rem;
    border-radius: 0.1rem;
    flex-shrink: 0;
    object-fit: cover;
  }

  .t1-recommend-name {
    width: 2.5rem;
    font-size: 0.24rem;
    color: #ccc;
    text-align: center;
    margin-top: 0.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.t1-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #0a0a0a;
  padding: 0.25rem 0.2rem 0.5rem;
  box-sizing: border-box;
  z-index: 100;

  .t1-footer-info {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.2rem;
    font-size: 0.26rem;
    color: #888;
    margin-bottom: 0.25rem;

    .t1-refresh {
      color: #DFB372;
    }
  }

  .t1-footer-btns {
    display: flex;
    gap: 0.2rem;

    .t1-btn {
      flex: 1;
      height: 0.85rem;
      line-height: 0.85rem;
      border: none;
      border-radius: 0.4rem;
      font-size: 0.32rem;
      font-weight: 600;
      text-align: center;
    }

    .t1-btn-back {
      background: transparent;
      border: 1px solid #DFB372;
      color: #DFB372;
    }

    .t1-btn-apply {
      background: #898989;
      color: #fff;
    }
  }
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .popup-content {
    position: relative;
    width: 80%;
    max-width: 3rem;
    background: #0a0a0a;
    border-radius: 0.1rem;
    padding: 0.2rem;
  }

  .popup-close {
    position: absolute;
    top: -0.4rem;
    right: -0.4rem;
    width: 0.4rem;
    height: 0.4rem;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .popup-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .popup-img {
    width: 100%;
    border-radius: 0.1rem;
    margin-bottom: 0.1rem;
  }

  .popup-name {
    font-size: 0.28rem;
    color: #fff;
    text-align: center;
  }
}
</style>

<style>
.t1-table-note strong {
  color: #e6f41f;
}
.t1-table-note-red {
  color: #e74c3c;
}
.t1-table-note-red .blue-text {
  color: #7c90f3;
}
.t1-rules {
  font-size: 0.28rem !important;
  color: #fff !important;
  line-height: 1.6 !important;
  width: 100% !important;
  margin: 0;
  padding: 0;
}
.t1-rules p {
  margin: 0 0 0.1rem 0;
  padding: 0;
}
.t1-rules strong {
  color: #fff !important;
  font-weight: 600;
}
.t1-rules .blue-text {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/activityDetail/template1.vue